import SEO from "@/components/SEO";
import CtaBanner from "@/components/CtaBanner";
import Testimonials from "@/components/Testimonials";
import GoogleReviews from "@/components/GoogleReviews";
import GoogleReviewsCard from "@/components/GoogleReviewsCard";
import { TESTIMONIALS } from "@/data/content";

export default function TestimonialsPage() {
  return (
    <>
      <SEO
        title="Testimonials — What Our Clients Say"
        description="Read real testimonials from 200+ Indian D2C brands scaled by Orina Enterprise on Amazon, Flipkart, Meesho, JioMart, Nykaa, Myntra, Blinkit and Zepto."
        path="/testimonials"
      />

      <section className="border-b-2 border-black bg-[#FFD700] py-20 md:py-28">
        <div className="mx-auto max-w-7xl px-4 md:px-8">
          <div className="tape-dark">Testimonials</div>
          <h1 className="display mt-6 max-w-4xl text-5xl font-black leading-[0.95] tracking-tight md:text-6xl lg:text-7xl">
            Brands. Outcomes.<br />
            <span className="bg-black px-2 text-[#FFD700]">Real numbers.</span>
          </h1>
          <p className="mt-6 max-w-2xl text-base text-black/80 md:text-lg">
            We don't sell hours — we sell outcomes. Here's what some of our clients have to say.
          </p>
        </div>
      </section>

      <section className="bg-white py-20 md:py-24">
        <div className="mx-auto max-w-7xl px-4 md:px-8">
          <GoogleReviewsCard className="mb-12 max-w-3xl" />
          <Testimonials limit={TESTIMONIALS.length} />
          <div className="mt-12">
            <GoogleReviews />
          </div>
        </div>
      </section>

      <CtaBanner
        title="Want to be the next case study?"
        subtitle="Free 30-minute audit. No commitments. We'll tell you exactly what's working and what's not."
      />
    </>
  );
}
